/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect } from 'react';
import { KEYBOARD_TYPES } from '~/data/constants';

type Props = {
  titles: string[];
  focusedValue: string;
  onChange?: (value: string) => void;
  onChangeWithEvent?: (value: any) => void;
  setFocusedValue?: React.Dispatch<React.SetStateAction<string>>;
  setFocusedValue2?: (value: string) => void;
  buttonsGroupRef: React.MutableRefObject<HTMLDivElement | null | undefined>;
  setIsChangeWithArrows?: React.Dispatch<React.SetStateAction<boolean>>;
  disables?: string[];
};

const useSwitchingTogglesArrows = ({
  titles,
  focusedValue,
  onChange,
  onChangeWithEvent,
  setFocusedValue,
  setFocusedValue2,
  buttonsGroupRef,
  setIsChangeWithArrows,
  disables = [],
}: Props) => {
  const handleKeyDown = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      const currentTitleIndex = titles.findIndex(
        (title) => title === focusedValue,
      );

      let newTitleIndex = -1;
      if (e.key === KEYBOARD_TYPES.ARROW_RIGHT) {
        newTitleIndex =
          currentTitleIndex > 0 ? currentTitleIndex - 1 : titles.length - 1;
      } else if (e.key === KEYBOARD_TYPES.ARROW_LEFT) {
        newTitleIndex =
          currentTitleIndex < titles.length - 1 ? currentTitleIndex + 1 : 0;
      }
      if (newTitleIndex > -1) {
        if (!disables.includes(titles[newTitleIndex])) {
          if (setFocusedValue2) {
            setFocusedValue2(titles[newTitleIndex]);
          }
          if (setFocusedValue) {
            setFocusedValue(titles[newTitleIndex]);
          }

          if (onChange) {
            onChange(titles[newTitleIndex]);
          }
          if (onChangeWithEvent) {
            const event = e;
            event.target.value = titles[newTitleIndex];
            onChangeWithEvent(event);
          }
        }
        if (setIsChangeWithArrows) {
          setIsChangeWithArrows(true);
        }
      }
    },
    [
      disables,
      focusedValue,
      onChange,
      onChangeWithEvent,
      setFocusedValue,
      setFocusedValue2,
      setIsChangeWithArrows,
      titles,
    ],
  );

  useEffect(() => {
    const currentButtonsGroupRef = buttonsGroupRef.current;
    if (buttonsGroupRef.current && focusedValue) {
      buttonsGroupRef.current.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      if (currentButtonsGroupRef) {
        currentButtonsGroupRef.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, [buttonsGroupRef, focusedValue, handleKeyDown, onChange]);
};

export default useSwitchingTogglesArrows;
